import { render, staticRenderFns } from "./ViewOrder.vue?vue&type=template&id=49fa15e2&scoped=true&lang=pug"
import script from "./ViewOrder.vue?vue&type=script&lang=js"
export * from "./ViewOrder.vue?vue&type=script&lang=js"
import style0 from "./ViewOrder.vue?vue&type=style&index=0&id=49fa15e2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fa15e2",
  null
  
)

export default component.exports